import { useBranchStore } from '@/store/branchStore';
import { getCustomUrlFromLocation } from '@/utils/branch';
import { useEffect } from 'react';

export function useBranchInit() {
  const {
    initialized,
    branchId,
    setCustomUrl,
    setInitialized,
    restoreFromCache,
    resolveByCustomUrl,
    loadBranchInfo,
    loadProducts,
    loadStorefrontChannel,
  } = useBranchStore();

  useEffect(() => {
    if (initialized) return;

    const detectedCustomUrl = getCustomUrlFromLocation();

    if (detectedCustomUrl) {
      setCustomUrl(detectedCustomUrl);
    }

    const hasCache = restoreFromCache();

    if (hasCache && branchId) {
      Promise.all([loadBranchInfo(), loadProducts(), loadStorefrontChannel()]);
      setInitialized();
      return;
    }

    if (detectedCustomUrl) {
      resolveByCustomUrl(detectedCustomUrl).then(() => {
        const state = useBranchStore.getState();
        if (state.branchId) {
          Promise.all([state.loadBranchInfo(), state.loadProducts()]);
        }
        setInitialized();
      });
    } else {
      setInitialized();
    }
  }, [
    initialized,
    branchId,
    setCustomUrl,
    setInitialized,
    restoreFromCache,
    resolveByCustomUrl,
    loadBranchInfo,
    loadProducts,
    loadStorefrontChannel,
  ]);
}
